import axios from "axios";
import {CalendarData, CreateOrderData, OpenDayTicketsData, OrderData} from "@/@types/api";


const configAuth = {
    auth: {
        // берем корневой домен, например vegas-hall.ru
        username: '', // todo через несколько дней убрать, когда кеш у клиентов удалится и всегда будет стартер передавать домен
        password: ''
    }
}

export function setAuthLogin(login: string) {
    configAuth.auth.username = login
}

const API_URL = 'https://api.vegas-ticket.ru/ocean/v3/'

export async function getOpenDateTickets(expositions=''): Promise<OpenDayTicketsData> {

    return new Promise((resolve, reject) => {
            axios.get(`${API_URL}/open_date_tickets?expositions=`+expositions, configAuth)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        }
    )

}

export async function getCalendar(expositions=''): Promise<CalendarData> {

    return new Promise((resolve, reject) => {
            axios.get(`${API_URL}/calendar?expositions=`+expositions, configAuth)
                .then(result => {
                    resolve(result.data.data)
                })
                .catch(err => {
                    reject(err)
                })
        }
    )

}

export async function createOnlineOrder(data: CreateOrderData): Promise<OrderData> {

    return new Promise((resolve, reject) => {
            axios.post(`${API_URL}/locks`, {expo_tickets: data.expo_tickets}, configAuth)
                .then(resultLock => {

                    axios.post(`${API_URL}/pay_orders`, {
                        lock_id: resultLock.data.data.lock_id,
                        promo: data.promo,
                        source: data.source,
                        user_information: {
                            name: data.name,
                            surname: '',
                            email: data.email,
                            phone: data.tel,
                            telegram: data.telegram,
                            sms_agreement: false,
                            email_agreement: false
                        },
                        success_url: "https://ocean.vegas-ticket.ru/success",
                        failure_url: "https://ocean.vegas-ticket.ru/fail",

                    }, configAuth)
                        .then(resultOrder => {

                            resolve(resultOrder.data.data)

                        })
                        .catch(err => {
                            reject(err)
                        })


                })
                .catch(err => {
                    reject(err)
                })
        }
    )

}

// export function cancelOrder(orderId) {
//      //axios.get(`${ROOT_URL}order_cancel`, orderId)
// }


// export async function getPromocodeData(eventId: string, promocode: string, segments: number[]): Promise<SegmentsDiscounts> {
//     return new Promise((resolve, reject) => {
//             axios.get(`${API_URL}/promocode/${eventId}/${promocode}`,
//                 {
//                     ...configAuth, params: {segments: segments.join(',')}
//                 })
//                 .then(result => {
//                     // от 1с придет с кодом сегмента строковым
//                     <{ [segmentId: string]: number }>result.data.data
//
//                     const segmentDiscounts: SegmentsDiscounts = new Map
//                     for (const key in result.data.data)
//                         segmentDiscounts.set(Number(key), result.data.data[key])
//
//                     resolve(result.data.data)
//                 })
//                 .catch(err => {
//                     reject(err)
//                 })
//         }
//     )
//
// }
